import React, { useEffect, useState } from "react";

const ScheduledReminders = () => {
  const [reminders, setReminders] = useState([]);
  const [filtered, setFiltered] = useState([]);

  const [vendorFilter, setVendorFilter] = useState("");
  const [poFilter, setPoFilter] = useState("");
  const [invoiceFilter, setInvoiceFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchReminders();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [vendorFilter, poFilter, invoiceFilter, statusFilter, fromDate, toDate, reminders]);

  const fetchReminders = async () => {
    try {
      setLoading(true);

      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/scheduled-reminders`);
      const data = await res.json();
      setReminders(Array.isArray(data) ? data : []);
      setFiltered(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error fetching reminders", err);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    let data = [...reminders];

    if (vendorFilter)
      data = data.filter(r => r.vendor_name?.toLowerCase().includes(vendorFilter.toLowerCase()));

    if (poFilter)
      data = data.filter(r => r.po_code?.toLowerCase().includes(poFilter.toLowerCase()));

    if (invoiceFilter)
      data = data.filter(r => r.invoice_number?.toLowerCase().includes(invoiceFilter.toLowerCase()));

    if (statusFilter)
      data = data.filter(r => r.status === statusFilter);

    if (fromDate)
      data = data.filter(r => new Date(r.reminder_date) >= new Date(fromDate));

    if (toDate)
      data = data.filter(r => new Date(r.reminder_date) <= new Date(toDate));

    setFiltered(data);
  };

  const formatDate = (d) => {
    if (!d) return "-";
    return new Date(d).toLocaleDateString();
  };

  return (
    <div
      style={{
        padding: "10px 30px",
        background: "#ECF0F3",
        minHeight: "100vh",
      }}
    >
      <div style={{ marginBottom: "25px" }}>
        <h2
          style={{
            fontSize: "26px",
            fontWeight: "700",
            color: "#424141",
          }}
        >
          ⏰ Scheduled Reminders
        </h2>
        <p style={{ color: "#6b7280", marginTop: "4px" }}>
          Track all vendor reminder schedules and delivery follow-ups
        </p>
      </div>

      <div
        style={{
          background: "#ffffff",
          padding: "10px 20px",
          borderRadius: "14px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          marginBottom: "25px",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))",
            gap: "15px",
            alignItems: "center",
          }}
        >
          <input
            placeholder="Vendor Name"
            value={vendorFilter}
            onChange={(e) => setVendorFilter(e.target.value)}
            className="reminder-input"
          />

          <input
            placeholder="PO Code"
            value={poFilter}
            onChange={(e) => setPoFilter(e.target.value)}
            className="reminder-input"
          />

          <input
            placeholder="Invoice Number"
            value={invoiceFilter}
            onChange={(e) => setInvoiceFilter(e.target.value)}
            className="reminder-input"
          />

          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="reminder-input"
          >
            <option value="">All Status</option>
            <option value="pending">Pending</option>
            <option value="sent">Sent</option>
          </select>

          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="reminder-input"
          />

          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            className="reminder-input"
          />
        </div>
      </div>

      {/* Table Card */}
      <div
        style={{
          background: "#ffffff",
          borderRadius: "14px",
          overflow: "hidden",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        }}
      >
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "14px",
            }}
          >
            <thead style={{ background: "#75BFB0", color: "#fff" }}>
              <tr>
                <th className="th">Id</th>
                <th className="th">Vendor</th>
                <th className="th">PO Code</th>
                <th className="th">Invoice</th>
                <th className="th">Invoice Date</th>
                <th className="th">Reminder Date</th>
                <th className="th">Send To</th>
                <th className="th">Status</th>
                <th className="th">Sent At</th>
              </tr>
            </thead>

            <tbody>
              { loading ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center", padding: "30px" }}>
                    <div className="loader"></div>
                  </td>
                </tr>
              ) : filtered.length === 0 ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center", padding: "30px" }}>
                    No reminders found
                  </td>
                </tr>
              ) : (
                filtered.map((r, index) => (
                  <tr
                    key={r.id}
                    style={{
                      background: index % 2 === 0 ? "#ffffff" : "#f9fafb",
                      transition: "0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "#eef7f5")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background =
                        index % 2 === 0 ? "#ffffff" : "#f9fafb")
                    }
                  >
                    <td className="td">{r.id}</td>
                    <td className="td">{r.vendor_name}</td>
                    <td className="td">{r.po_code}</td>
                    <td className="td">{r.invoice_number}</td>
                    <td className="td">{formatDate(r.invoice_date)}</td>
                    <td className="td">{formatDate(r.reminder_date)}</td>
                    <td className="td">{r.send_to}</td>

                    <td className="td">
                      <span
                        style={{
                          padding: "4px 12px",
                          borderRadius: "20px",
                          fontSize: "12px",
                          fontWeight: "600",
                          background:
                            r.status === "sent"
                              ? "#d1fae5"
                              : "#fee2e2",
                          color:
                            r.status === "sent"
                              ? "#065f46"
                              : "#991b1b",
                        }}
                      >
                        {r.status.toUpperCase()}
                      </span>
                    </td>

                    <td className="td">
                      {r.sent_at ? formatDate(r.sent_at) : "-"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <style>{`
        .reminder-input{
          padding:11px 12px;
          border-radius:8px;
          border:1px solid #d1d5db;
          font-size:14px;
          outline:none;
          width:100%;
          box-sizing:border-box;
        }

        .reminder-input:focus{
          border-color:#75BFB0;
          box-shadow:0 0 0 2px rgba(117,191,176,0.2);
        }

        .th{
          padding:12px;
          text-align:left;
          font-weight:600;
        }

        .td{
          padding:12px;
        }

        .loader {
          border: 4px solid #f3f3f3;
          border-top: 4px solid #75BFB0;
          border-radius: 50%;
          width: 35px;
          height: 35px;
          animation: spin 1s linear infinite;
          margin: auto;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default ScheduledReminders;